import RequestType from "../constants/request-type";
import { getOrderOptions } from "../sdk/get-order-options";
import { getVehicleLookup } from "../sdk/get-vehicle-lookup";
import { getInsuranceOptions } from "../sdk/get-insurance-options";
import { getAddressLookup } from "../sdk/get-address-lookup";
import { getPaymentLookup } from "../sdk/get-payment-lookup";
import { createOrder } from "../sdk/create-order";
import bankIdAuth from "../sdk/bankid/auth";
import bankIdCollect from "../sdk/bankid/collect";
import bankIdCancel from "../sdk/bankid/cancel";
import createCreditAssessmentCase from "../sdk/credit-assessment/new-case";
import declineCreditAssessmentCase from "../sdk/credit-assessment/decline-case";
import acceptCreditAssessmentCase from "../sdk/credit-assessment/accept-case";
import signCreditAssessmentCaseWithQrCode from "../sdk/credit-assessment/sign-with-qr-code";
import signCreditAssessmentCaseWithSameDevice from "../sdk/credit-assessment/sign-with-same-device";
import cancelCreditAssessmentSigning from "../sdk/credit-assessment/cancel-signing";
import getCreditAssessmentStatus from "../sdk/credit-assessment/get-status";
const requestCache = {};
const getCachedRequestResponse = (requestType, requestIdentifier, dealerIdentifier) => {
    if (requestIdentifier === null) {
        return null;
    }
    const cachedRequest = requestCache[requestType];
    if (!cachedRequest) {
        return null;
    }
    let key = requestIdentifier;
    if (dealerIdentifier)
        key = `${key}/${dealerIdentifier}`;
    const isSameIdentifier = key === cachedRequest.identifier;
    return isSameIdentifier ? cachedRequest.response : null;
};
const addRequestToCache = (requestType, requestIdentifier, dealerIdentifier, response) => {
    if (requestIdentifier === null) {
        return;
    }
    let key = requestIdentifier;
    if (dealerIdentifier)
        key = `${key}/${dealerIdentifier}`;
    requestCache[requestType] = {
        response,
        identifier: key,
    };
};
const makeRequest = (requestAction, requestType, requestIdentifier, dealerIdentifier, data, callback) => {
    const cachedRequestResponse = getCachedRequestResponse(requestType, requestIdentifier, dealerIdentifier);
    if (cachedRequestResponse) {
        return callback(cachedRequestResponse);
    }
    requestAction(data, (response) => {
        if (response) {
            addRequestToCache(requestType, requestIdentifier, dealerIdentifier, response);
        }
        callback(response);
    });
};
export const makeOrderOptionsRequest = (data, callback) => {
    const requestIdentifier = data.vehicleId;
    const dealerIdentifier = data.dealerId;
    makeRequest(getOrderOptions, RequestType.GET_ORDER_OPTIONS, requestIdentifier, dealerIdentifier, data, callback);
};
export const makeVehicleLookupRequest = (data, callback) => {
    const requestIdentifier = `${data.ecomData.registrationNumber}${data.ecomData.milage}${data.ecomData.condition}`;
    makeRequest(getVehicleLookup, RequestType.GET_VEHICLE_LOOKUP, requestIdentifier, null, data, callback);
};
export const makeInsuranceOptionsRequest = (data, callback) => {
    const requestIdentifier = `${data.vehicleId}${data.paymentType}${data.ecomData.expectedDrivingDistance}${data.ecomData.personalNumber}`;
    makeRequest(getInsuranceOptions, RequestType.GET_INSURANCE_OPTIONS, requestIdentifier, null, data, callback);
};
export const makeAddressLookupRequest = (data, callback) => {
    const requestIdentifier = data.ecomData.personalNumber;
    makeRequest(getAddressLookup, RequestType.GET_ADDRESS_LOOKUP, requestIdentifier, null, data, callback);
};
export const makePaymentLookupRequest = (data, callback) => {
    const requestIdentifier = `${data.ecomData.loanDeposit}${data.ecomData.loanDuration}${data.ecomData.loanResidual}`;
    const dealerIdentifier = data.dealerId;
    makeRequest(getPaymentLookup, RequestType.GET_PAYMENT_LOOKUP, requestIdentifier, dealerIdentifier, data, callback);
};
export const makeCreateOrderRequest = (data, callback) => {
    const requestIdentifier = null;
    makeRequest(createOrder, RequestType.CREATE_ORDER, requestIdentifier, null, data, callback);
};
export const makeBankIdAuthRequest = (data, callback) => {
    const requestIdentifier = null;
    makeRequest(bankIdAuth, RequestType.BANK_ID_AUTH, requestIdentifier, null, data, callback);
};
export const makeBankIdCollectRequest = (data, callback) => {
    const requestIdentifier = null;
    makeRequest(bankIdCollect, RequestType.BANK_ID_COLLECT, requestIdentifier, null, data, callback);
};
export const makeBankIdCancelRequest = (data, callback) => {
    const requestIdentifier = null;
    makeRequest(bankIdCancel, RequestType.BANK_ID_CANCEL, requestIdentifier, null, data, callback);
};
export const makeCreditAssessmentCreateCaseRequest = (inquiry, callback) => {
    const requestIdentifier = null;
    makeRequest(createCreditAssessmentCase, RequestType.CREATE_CREDIT_ASSESSMENT_CASE, requestIdentifier, null, inquiry, callback);
};
export const makeCreditAssessmentDeclineRequest = (caseId, callback) => {
    const requestIdentifier = null;
    makeRequest(declineCreditAssessmentCase, RequestType.DECLINE_CREDIT_ASSESSMENT_CASE, requestIdentifier, null, caseId, callback);
};
export const makeCreditAssessmentAcceptRequest = (caseId, callback) => {
    const requestIdentifier = null;
    makeRequest(acceptCreditAssessmentCase, RequestType.DECLINE_CREDIT_ASSESSMENT_CASE, requestIdentifier, null, caseId, callback);
};
export const makeCreditAssessmentQrCodeSignRequest = (caseId, callback) => {
    const requestIdentifier = null;
    makeRequest(signCreditAssessmentCaseWithQrCode, RequestType.SIGN_CREDIT_ASSESSMENT_WITH_QR_CODE, requestIdentifier, null, caseId, callback);
};
export const makeCreditAssessmentSameDeviceSignRequest = (caseId, callback) => {
    const requestIdentifier = null;
    makeRequest(signCreditAssessmentCaseWithSameDevice, RequestType.SIGN_CREDIT_ASSESSMENT_WITH_SAME_DEVICE, requestIdentifier, null, caseId, callback);
};
export const makeCreditAssessmentCancelSigningRequest = (caseId, callback) => {
    const requestIdentifier = null;
    makeRequest(cancelCreditAssessmentSigning, RequestType.CANCEL_CREDIT_ASSESSMENT_SIGNING, requestIdentifier, null, caseId, callback);
};
export const makeCreditAssessmentGetStatusRequest = (caseId, callback) => {
    const requestIdentifier = null;
    makeRequest(getCreditAssessmentStatus, RequestType.GET_CREDIT_ASSESSMENT_STATUS, requestIdentifier, null, caseId, callback);
};
